<template>
  <div class="d-flex align-items-center flex-column">
    <div class="card px-6 py-4 my-4 w-100 mw-650px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="'/inventory/export'">Phiếu xuất hàng</el-breadcrumb-item>
        <el-breadcrumb-item>{{ isCreate ? 'Tạo phiếu xuất hàng' : 'Chi tiết phiếu xuất hàng' }}</el-breadcrumb-item>
      </el-breadcrumb>
      <h4 class="mt-3">{{ isCreate ? 'Tạo phiếu xuất hàng' : 'Chi tiết phiếu xuất hàng' }}</h4>
    </div>
    <div class="card px-6 py-4 my-4 w-100 mw-650px">
      <h5>Thông tin cơ bản</h5>

      <div class="mt-3">
        <el-form
          :model="exportForm"
          :rules="exportFormRules"
          ref="validateForm"
          label-width="150px"
          class="demo-ruleForm flex-column"
          
        >
          <el-form-item label="Mã phiếu xuất" prop="cCode">
            <el-input
              v-model="exportForm.cCode"
              :readonly="exportForm.nTrangThai !== 0"
            />
          </el-form-item>
          <el-form-item label="Tên phiếu xuất" prop="cTenPhieuXuat">
            <el-input
              v-model="exportForm.cTenPhieuXuat"
              :readonly="exportForm.nTrangThai !== 0"
            />
          </el-form-item>
          <el-form-item label="Ghi chú" prop="cGhiChu">
            <el-input
              type="textarea"
              :rows="3"
              v-model="exportForm.cGhiChu"
              :readonly="exportForm.nTrangThai !== 0"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="card px-6 py-4 my-4 w-100 mw-650px">
      <h5>Sản phẩm</h5>
      <div>
        <el-autocomplete
          size="medium"
          style="margin-bottom: 20px; width: 100%"
          :fetch-suggestions="querySearch"
          v-model="searchProduct"
          @select="handleSelectSuggestionProduct"
          placeholder="Nhập tên sản phẩm"
          v-if="exportForm.nTrangThai === 0"
        >
          <i
            class="el-icon-search el-input__icon"
            slot="suffix"
          />
          <template slot-scope="{ item }">
            <div style="display: flex; gap: 10px; padding: 5px">
              <el-image
                style="width: 50px; height: 50px"
                :src="baseUrl + '/product/img/' + item.odooImage1920"
                :fit="'fill'"
              />
              <span>{{ item.odooName }}</span>
            </div>
          </template>
        </el-autocomplete>
      </div>


      <el-table
        :data="listDetailExportForm"
        header-row-class-name="thead-light"
        :border="true"
        
        fit
      >
        <el-table-column prop="odooName" label="Sản phẩm" >
          <template #default="scope">
            <div style="display: flex; gap: 10px">
              <el-image
                style="width: 50px; height: 50px"
                :src="baseUrl + '/product/img/' + scope.row.odooImage1920"
                :fit="'fill'"
              />
              <span>{{ scope.row.odooName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Tồn kho" prop="maxSoLuong" width="100" align="center" v-if="isCreate" />

        <el-table-column label="Số lượng dự kiến" width="180" align="center" prop="nSoLuong">
          <template #default="scope">
            <el-input-number
              v-model="scope.row.nSoLuong"
              :min="0"
              :max="scope.row.maxSoLuong"
              size="'mini'"
              style="width: 100%"
              v-if="exportForm.nTrangThai === 0"
            />
            <span v-else>{{scope.row.nSoLuong}}</span>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center" v-if="exportForm.nTrangThai === 0">
          <template #default="scope">
            <i class="el-icon-delete" style="color: red; cursor: pointer" @click="handleDelete(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="card px-6 py-4 my-4 d-flex align-items-center justify-content-end flex-row w-100 mw-650px" style="text-align: right">
      <el-button
        outline
        type="secondary"
        :disabled="isLoading"
        @click="$router.push({name: 'Export'})"
      >
        Thoát
      </el-button>
      <el-button
        type="primary"
        @click="handleAddNew"
        v-if="exportForm.nTrangThai === 0"
        :disabled="isLoading"
      >
        Lưu
      </el-button>

    </div>
  </div>
</template>
<script>
import { Inventory, Product } from "@/store/enums/StoreEnums";
import {baseUrl} from "@/utils/global"
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
const oExportForm = {
  cCode: "",
  cTenPhieuXuat: "",
  cGhiChu: "",
  nTrangThai: 0
}

const oDetailExportForm = {
  nMaSanPham: "",
  nSoLuong: 0,
}

export default {
  data() {
    return {
      store:useStore(),
      baseUrl: baseUrl,
      //
      exportForm: Object.assign({}, oExportForm),
      exportFormRules: {
        cTenPhieuXuat: [
          { required: true, message: "Vui lòng nhập tên phiếu xuất", trigger: "blur" },
        ],
      },
      //
      detailExportForm: Object.assign({}, oDetailExportForm),
      listDetailExportForm: [],
      tempListDetailExportForm: [],
      //
      dialogSelectProduct: false,
      pageRequest: { pageNum: 1, pageSize: 5 },
      tableData: [],
      searchProduct: "",
      isLoading: false,
      //
      isCreate: true,
      exportId: 0,

    }
  },
  methods: {
    querySearch(queryString, cb) {
      let tempData = this.tableData
      let results = queryString ? tempData.filter(this.createFilter(queryString)) : tempData;
      // // call callback function to return suggestion objects
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (data.odooName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    async getListProduct() {
      const res = await this.store.dispatch(Product.showProduct)
      if(res.code === 200) {
        this.tableData = res.data.filter(e => e.nSoLuong > 0)

        if(!this.isCreate && this.listDetailExportForm.length > 0) {
          this.tableData = this.tableData.filter(item => {
            return !this.listDetailExportForm.some(removeItem => {
              return item.nMaSanPham === removeItem.nMaSanPham;
            });
          });
        }
      }
    },

    handleSelectSuggestionProduct(item) {
      item.maxSoLuong = item.nSoLuong
      item.nSoLuong = 1

      this.tableData =  this.tableData.filter(e => e.nMaSanPham !== item.nMaSanPham)
      this.listDetailExportForm.push(item)
    },

    handleAddNew() {
      this.$refs.validateForm.validate(async (valid) => {
        if (valid) {
          this.isLoading = true

          this.exportForm.sysChiTietPhieuXuatList = this.listDetailExportForm

          if(this.isCreate) {
            const res = await this.store.dispatch(Inventory.newExport,this.exportForm)
            if(res.code === 200) {
              ElMessage({ message: "Thêm mới thành công", type: "success" })
              this.$router.push({name: 'Export'})
            }
          } else {
            const res = await this.store.dispatch(Inventory.updateExport,this.exportForm)
            if(res.code === 200) {
              await this.findExportById()
              ElMessage({ message: "Chỉnh sửa thành công", type: "success" })
              this.isLoading = false
            }
          }

        }
      })

    },
    handleDelete(item) {
      this.listDetailExportForm = this.listDetailExportForm.filter(e => e.nMaSanPham !== item.nMaSanPham)
      this.tableData.push(item)
    },

    async findExportById() {
      const res = await this.store.dispatch(Inventory.findExportById,this.exportId)
      if(res.code === 200) {
        this.exportForm = res.data
        this.listDetailExportForm = res.data.sysChiTietPhieuXuatList
      }
    },

  },
  async mounted() {
    if(this.$route.params.id) {
      this.exportId = this.$route.params.id
      this.isCreate = false
      await this.findExportById()
    }
    await this.getListProduct()
  }
}
</script>
<style>
.container .card-v {
  background-color: white;
  width: 80%;
  margin: auto;
  padding: 20px;
  box-shadow: 1px 1px 5px 0px #ccc;
  border-radius: 5px;
  margin-bottom: 20px;
}

.tableSelectProduct .el-table-column--selection .cell {
  min-width: 48px !important;
}
</style>
